import React, { Suspense } from 'react';
import 'react-calendar/dist/Calendar.css';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppLayout from '@components/Layout/AppLayout';
import GlobalLayout from '@components/Layout/GlobalLayout';
import OkCancelDialog from '@components/common/OkCancelDialog';
import { CommentModal } from '@components/modal/CommentModal';
import ProductOrderDetailModal from '@components/modal/ProductOrderDetailModal';
import { ProductPreViewModal } from '@components/modal/ProductPreViewModal';
import RefundProductOrderModal from '@components/modal/RefundProductOrderModal';
import ChangeScheduleModal from '@components/platform-sale-history/ChangeScheduleModal';
import { useAppSocket } from '@hooks/appSocket';
import { useSessionLogger } from '@hooks/sessionLogger';
import './App.scss';
import routes from './routes';

const App: React.FC = () => {
  useAppSocket();
  useSessionLogger();

  return (
    <>
      <Routes>
        <Route element={<GlobalLayout />}>
          {routes.map((route, index) => (
            <Route
              key={`route-${index}`}
              path={route.path}
              element={
                <Suspense
                  fallback={
                    <AppLayout>
                      <div />
                    </AppLayout>
                  }>
                  {route.element}
                </Suspense>
              }
            />
          ))}
        </Route>
      </Routes>
      <OkCancelDialog />
      <CommentModal />
      <ProductPreViewModal />
      <ChangeScheduleModal />
      <ProductOrderDetailModal />
      <RefundProductOrderModal />
      <ToastContainer />
    </>
  );
};

export default App;
